import messages from '@/i18n/messages'
import {createI18n} from 'vue-i18n'

export const i18n = createI18n({
  locale: 'en',
  legacy: false,
  messages
})

